import { Component } from '@angular/core';
import { AlertController, IonicPage, LoadingController, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { UtilsProvider } from '../../providers/utils/utils';
import { CajaProvider } from '../../providers/caja/caja';
import { PushProvider } from '../../providers/push/push';
import { AppState } from '../../app/app.reducer';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/observable/from';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import { Estados } from '../../models/estados/estados.models';
import { AuthService } from '../../providers/auth-service';
import { CompaniasProvider } from '../../providers/companias/companias';

@IonicPage()
@Component({
  selector: 'gestionar-interes-creditos-por-costos-adicionales',
  templateUrl: 'gestionar-interes-creditos-por-costos-adicionales.html',
  providers: [PushProvider,AuthService]
})
export class GestionarInteresesCreditosPorCostosAdicionalesComponent {
  listaProductosSeleccionados = []
  permiteEliminarPedido: boolean = false
  valorTotalVenta = 0
  infoResponse = []
  devolverVenta: boolean = false;
  mesaCambio = []
  mesasIdMesaCambio;
  turnosArray = [];
  domicilioSeleccionada: string = 'N'
  valorTotalServicio:number= 0
  valorTotalProductos:number = 0
  valorTotalImpuestos:number = 0
  formaPagoSeleccionada: string = 'O'
  CheckPorcentajeServicio:boolean = false
  datosAdicionales
  valorTotalDevolver = 0
  loader
  mesaSeleccionada
  price = 0
  subscriptionProductosSeleccionados: Subscription;
  porcentajeServicioValor: string = 'N'
  descripcionVenta: string = ''
  estado: Estados =  {
    clienteSelect: false,
    usuarioSelect: false,
    grupos: true,
    productos: false,
    pedidos: false,
    mesas: false,
    response: false
  }
  clienteId = []
  valoresCliente: string = '';
  usuarioId = [];
  valoresUsuario: string = '';
  imprimirProducto: boolean = true;
  imprimirGeneral: boolean = true;
  reconocimientoActivo: boolean = false;
  recognition: any;
  grabando: boolean = false;
  imprimirParcial: boolean = false;
  eliminarRegistroIndividual: boolean = false;
  constosAdicionalesExistentes:any = []
  constosAdicionalesParaIngresar:any = []
  tipo:string='P'
  interesesCreditosId = 0
  numerocuota = ''
  valor = 0
  arrastrarValor:string = 'N'
  arrastrarValorTexto:string = 'NO'
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public viewControllers:ViewController,
              public utilsMensajero:UtilsProvider,
              public servicio: CajaProvider,
              public storage: Storage,
              public push:PushProvider,
              public loadingCtrl: LoadingController,
              public alertControllers: AlertController,
              private storePedidosSalon: Store<AppState>,
              public modalControllers: ModalController,
              public auth: AuthService,
              public servicioCompania: CompaniasProvider) {
      this.numerocuota = this.navParams.get('numeroCuota')
      let companiasId = this.navParams.get('companiasId')
      this.valor = this.navParams.get('valor')
      this.interesesCreditosId = this.navParams.get('interesesCreditosId')
      this.buscarDatosIniciales(companiasId,this.interesesCreditosId)
  }

  buscarDatosIniciales(companiasId:any,interesesCreditosId:any) {
    this.constosAdicionalesExistentes = []
    this.constosAdicionalesParaIngresar = []
    this.servicioCompania.buscarInteresesCreditosPorCostosAdicionales(companiasId,interesesCreditosId)
    .subscribe((data)=> {
      let responsedata = JSON.parse(data['_body']).data
      if(responsedata.length>0) {
        this.constosAdicionalesExistentes = responsedata[0]
        this.constosAdicionalesParaIngresar = responsedata[1]
        this.constosAdicionalesParaIngresar = this.constosAdicionalesParaIngresar.filter(itemB =>
          !this.constosAdicionalesExistentes.some(itemA => itemA.costosAdicionalesId === itemB.costosAdicionalesId)
      );

      }
    }, (error)=> {
      console.log(error)
    })
  }

  eliminarGestion(item:any) {
    let datos = {
      interesesCreditosPorCostosAdicionalesId: item.interesesCreditosPorCostosAdicionalesId,
      queHago:'E',
      name: 'dataDynamicCrud'
    }
    let costosAdicionalesId = item.costosAdicionalesId
    let companiasId = item.companiasId
    this.servicioCompania.eliminarGestionInteresCreditosPorCostosAdicionales(datos)
    .subscribe((data)=> {
       if(this.arrastrarValor === 'S') {
        this.servicioCompania.interesesCreditosPorCostosAdicionalesArrastrarValor(companiasId,costosAdicionalesId,'T','S').subscribe((data)=> {
          this.buscarDatosIniciales(companiasId,this.interesesCreditosId)
          this.arrastrarValor = 'N'
          this.arrastrarValorTexto = 'NO'
        },(error)=> console.log(error))
       }
        else {
        this.buscarDatosIniciales(companiasId,this.interesesCreditosId)
        this.arrastrarValor = 'N'
        this.arrastrarValorTexto = 'NO'
       }
    }, (error)=> {
      console.log(error)
    })
  }

  dismiss(){
    this.cerrarModal()
  }

  submit(){
    this.cerrarModal()
  }
cerrarModalVentaGenerada() {
  this.cerrarModal()
}

cerrarModal() {
  this.viewControllers.dismiss(this.infoResponse);
}

ionViewDidLoad() {
  const element = document.getElementsByClassName('modal-wrapper')[0] as HTMLElement;
  element.style.height = '100%';
  element.style.width = '100%';
  element.style.top = '0';
  element.style.left = '0';
  element.style.right = '0';
  element.style.bottom = '0';
}

async guardar(item:any) {
  if(item.tipo === undefined) {
    this.utilsMensajero.mensajeMuestro('tipo de costo','Debe seleccionar un tipo de valor','warning')
    return
  }
  if(Number(item.valorCostoMensual) > 99 && item.tipo === "P") {
    this.utilsMensajero.mensajeMuestro('TIPO PORCENTAJE','VALIDE SI EL TIPO QUE DESEA INGRESAR ES UN PORCENTAJE Y/0 CAMBIE EL VALOR DEL COSTO','warning')
    return
  }

  let datos = {
    interesesCreditosId: this.interesesCreditosId,
    costosAdicionalesId: item.costosAdicionalesId,
    companiasId: item.companiasId,
    tipo:item.tipo,
    queHago:'I',
    name: 'dataDynamicCrud'
  }
  let costosAdicionalesId = item.costosAdicionalesId
  let companiasId = item.companiasId
  let tipo = item.tipo
  this.servicioCompania.guardarGestionInteresCreditosPorCostosAdicionales(datos).subscribe((data)=> {
  if(this.arrastrarValor === 'S') {
    this.servicioCompania.interesesCreditosPorCostosAdicionalesArrastrarValor(companiasId,costosAdicionalesId,tipo,'S').subscribe((data)=> {
      this.buscarDatosIniciales(companiasId,this.interesesCreditosId)
      this.arrastrarValor = 'N'
      this.arrastrarValorTexto = 'NO'
    },(error)=> console.log(error))
   }
    else {
    this.buscarDatosIniciales(companiasId,this.interesesCreditosId)
    this.arrastrarValor = 'N'
    this.arrastrarValorTexto = 'NO'
   }
  }, (error)=> {
    console.log(error)
  })
}
toggleArrastrarValor() {
  this.arrastrarValor = this.arrastrarValor === 'N' ? 'S' : 'N';
  if(this.arrastrarValor === 'N') {
    this.arrastrarValorTexto = 'NO'
  } else {
    this.arrastrarValorTexto = 'SI'
  }
}
}




// WEBPACK FOOTER //
// ./src/pages/gestionar-interes-creditos-por-costos-adicionales/gestionar-interes-creditos-por-costos-adicionales.ts